import s from './teacher-infо.module.scss'
import classNames from 'classnames'
import { useParams } from 'react-router-dom'
import { useTeacher } from '@entities/teacher/api/useTeacher'
import { getNoun } from '@utils/lib/getNoun'
import { getAppointmentCount } from '@utils/lib/selectReviews'
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji'

export const TeacherInfo = ({ variant = 'default' }) => {
	const {id} = useParams()
	const { data: teacher } = useTeacher(id)
	const isPlain = variant === 'plain'

	return (
		<div className={classNames(s.baseInfo, isPlain && s.baseInfoPlain)}>
			<div className={s.avatar}>
				<img src={teacher?.avatar ? process.env.REACT_APP_STORAGE_URL + teacher?.avatar.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
			</div>
			<div>
				<h5 className={s.name}>
					{teacher?.name}
				</h5>
				<div className={s.infos}>
					<p><TextWithEmoji text={'🌟'}/> {teacher?.rating}</p>
					<p><TextWithEmoji text={'📖'}/> {getAppointmentCount(teacher)} {getNoun(getAppointmentCount(teacher), 'занятие', 'занятия', 'занятий')}</p>
					<p><TextWithEmoji text={'💬'}/> {teacher?.reviews?.length} {getNoun(teacher?.reviews?.length, 'отзыв', 'отзыва', 'отзывов')}</p>
				</div>
			</div>
		</div>
	)
}
